import { AfterViewInit, Component, OnInit } from "@angular/core";
import { DrawingService } from "src/app/Services/DrawingService";

@Component({
    selector: 'app-spot-ticker',
    templateUrl: './spot-ticker.component.html',
    styleUrls: ['./spot-ticker.component.scss']
  })

  export class SpotTickerComponent
  {
        constructor(public drawingService:DrawingService)
        {

        }
  }